<template>
  <BaseListPage
      :name="name"
      :no-condition="false"
      :base-query="baseQuery"
      :store-path="storePath"
      :response-path="responsePath"
      :save-key="saveKey"
      :table-set-list="tableSetList"
      :table-data-list="sortedList"
      title="EC在庫アラート設定一覧"
      title-class="stockAlert-header"
      icon="stock"
      table-class="row-clickable-table"
      @row-click="onRowClick">
    <span slot="headerAction"
        class="action_button">
      <el-dropdown
          v-show="$isFunctionShown(define.PermissionKeys.Stock.Alert.Detail.NEW)"
          @command="actionCommand">
        <el-button size="small">
          アクション
          <i class="el-icon-arrow-down el-icon--right" />
        </el-button>
        <el-dropdown-menu
            slot="dropdown"
            class="header-action-menu">
          <el-dropdown-item
              :disabled="$isFunctionDisabled(define.PermissionKeys.Stock.Alert.Detail.NEW)"
              :command="define.STOCK_ALERT_MODE.NEW">
            新規登録
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </span>
  </BaseListPage>
</template>

<script>
import _ from 'lodash'
import { mapState, mapGetters } from 'vuex'

import * as define from '@/define'
import * as query from '@/queries/stock'
import x from '@/components/mixins/mixin'

import { ELEMENT_TYPE } from '@/components/molecules/BaseCell'
import BaseListPage from '@/components/organisms/BaseListPage'

export default {
  name: 'StockAlertList',
  components: {
    BaseListPage
  },
  mixins: [x],
  provide () {
    return {
      parentValidator: this.$validator
    }
  },
  data () {
    return {
      localIsParentLoaded: false
    }
  },
  computed: {
    define: () => define,
    ...mapState({
      listIndex: (state) => state.StockAlert.listIndex,
      tableSetList: (state) => state.StockAlert.tableSetList
    }),
    ...mapGetters({
      getSortedList: 'sortedList',
      getServiceSiteConfig: 'getServiceSiteConfig'
    }),
    ...mapGetters('LocalStorage', {
      sortCondition: 'sortCondition'
    }),
    name () {
      return 'stockAlertList'
    },
    storePath () {
      return 'StockAlert'
    },
    saveKey () {
      return 'stockAlertCondition'
    },
    responsePath () {
      return 'data.ecStockAlertItems.edges'
    },
    linkKey () {
      return 'node.uuid'
    },
    returnPath () {
      return '/stockAlert'
    },
    baseQuery () {
      return query.GRAPH_QL_QUERY_STOCK_ALERT_LIST
    },
    sortedList () {
      return this.getSortedList(this.storePath, this.sortCondition(this.name))
    },
    _tableSetList () {
      return [
        { type: 'String', label: 'サイト', path: 'node.ecStockAlert.site.name', sortable: 'custom' },
        { type: 'String', label: '有効', path: this.isEnabled, sortable: 'custom', elementType: ELEMENT_TYPE.TAG,
          class: 'center', size: 'small', width: '200px' },
        { type: 'String', label: '適用順', path: 'node.no', sortable: 'custom', width: '150px' },
        { type: 'String', label: '対象商品', path: 'node.productId', sortable: 'custom' },
        { type: 'String', label: '対象在庫種別', path: 'node.stockType', codeName: 'm_ec_stock_alert.stock_type', sortable: 'custom',
          width: '150px', class: 'center' },
        { type: 'String', label: '設定', path: this.alertSet, sortable: 'custom', elementType: ELEMENT_TYPE.TAG,
          class: 'center', size: 'small', width: '250px' },
        { type: 'String', label: '備考', path: 'node.note', sortable: 'custom' }
      ]
    }
  },
  created () {
    this.$store.dispatch({
      type: 'set',
      states: {
        'StockAlert/tableSetList': this._tableSetList
      }
    })
  },
  methods: {
    onRowClick (row, column, event) {
      const id = _.get(row, this.linkKey)
      const index = this.$_mixin_findIndex(this.sortedList, { [this.linkKey]: id })
      this.$_mixin_onLinkClick(index, this.storePath)
      this.$router.push({ path: `/stockAlert/${id}` })
    },
    /**
     * 一覧アラート有効を返却します。
     * @param {Object} 情報
     * @returns {Array} tag 生成のための配列
     */
    isEnabled: function (row) {
      const name = this.getCodeName('is_enabled', row.node.isEnabled.toString())
      let isEnabledTag = []
      if (row.node.isEnabled === 1) {
        isEnabledTag.push({ label: name, type: 'tag-blue-dark-1' })
      }
      if (row.node.isEnabled === 0) {
        isEnabledTag.push({ label: name, type: 'info' })
      }
      return isEnabledTag
    },
    /**
     * アラート設定情報を返却します。
     * @param {Object} 情報
     * @returns {Array} tag 生成のための配列
     */
    alertSet: function (row) {
      let value = ''
      const name = this.getCodeName('alert_type', row.node.alertType.toString())
      value = Number(row.node.alertValue) + ' | ' + name
      let isEnabledTag = []
      isEnabledTag.push({ label: value })
      return isEnabledTag
    },
    /**
     * コード値を返却します。
     * @param {key2}} キー2
     * @param {key3}} キー3
     * @returns {value} 値を返却
     */
    getCodeName (key2, key3) {
      return _.get(
        this.getServiceSiteConfig(null, 'm_ec_stock_alert', key2, key3),
        'label'
      )
    },
    /**
     * アクションボタン
     * @param {Number} mode モード
     */
    actionCommand: async function (mode) {
      switch (mode) {
        case define.STOCK_ALERT_MODE.NEW:
          this.createStockAlert()
          break
        default:
          break
      }
    },
    /**
     * アラート新規
     */
    createStockAlert () {
      this.$_mixin_onLinkClick(this.listIndex, this.storePath, define.STOCK_ALERT_MODE.NEW)
      this.$router.push({ path: 'stockAlert/0' })
    }
  }
}
</script>
